import { useState } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import useNotify from "hooks/useNotify";
import externalPageApi from "api/externalPage";

const useConfirmPOAssignee = () => {
  const [t] = useTranslation();
  const navigate = useNavigate();
  const { notifyError } = useNotify();
  const { search } = useLocation();
  const { token } = useParams();
  const approvedParam = new URLSearchParams(search).get("approved");

  const [isLoading, setIsLoading] = useState(false);
  const [successMsg, setSuccessMsg] = useState("");

  const onSubmit = async () => {
    try {
      setIsLoading(true);
      const payload = {
        token,
        acceptence: approvedParam,
      };

      await externalPageApi.respondPurchaseOrder(payload);
      setSuccessMsg(
        approvedParam === "true"
          ? t("poAcceptMsg")
          : t("rejectTask")
      );
    } catch (err) {
      console.error(err);
      notifyError(
        err?.response?.data?.message ?? err?.message ?? "Something went wrong!"
      );
    } finally {
      setIsLoading(false);
    }
  };

  return { onSubmit, navigate, isLoading, approvedParam, successMsg };
};

export default useConfirmPOAssignee;
